import React, { useState, useRef, useEffect } from "react";
import { classNames } from "primereact/utils";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useAuthStore } from "../../../store/AuthStore";
import { useSchoolStore } from "../../../store/SchoolStore";
import utils from "../../../utils";
import constants from "../../../constants";
import { addLevel, deleteLevel, editLevel } from "../../../apis/Level";

const LevelAddEdit = ({
  toast,
  levelAE,
  levelDialog,
  setLevelDialog,
}) => {
  const [state] = useAuthStore();
  const [{ schoolId }] = useSchoolStore();
  const [, setDeleteLevelDialog] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const toastLAE = useRef(toast);
  const [loading, setLoading] = useState(false);

  const emtyLevel = {
    id: levelAE && levelAE != null ? levelAE.id : null,
    schoolId: schoolId,
    name: levelAE && levelAE != null ? levelAE.name : "",
    description: levelAE && levelAE != null ? levelAE.description : "",
    createdBy: state.email,
    modifiedBy: state.email,
  };

  const [level, setLevel] = useState(emtyLevel);

  useEffect(() => {
    setLevel(emtyLevel);
  }, [levelAE]);

  const hideDialog = () => {
    setSubmitted(false);
    setLevelDialog(false);
  };

  async function deleteLevelFunc(data) {
    await deleteLevel(data.id);
  }

  const saveLevel = async () => {

    if (loading) return;

    setLoading(true);

    setSubmitted(true);

    let resp = {
      data: null,
      responseCode: "",
      responseCodeDescription: "",
    };

    try {
      if (level.name.trim()) {
        let _level = { ...level };

        if (_level.id) {
          _level.modifiedBy = state.email;

          resp = await editLevel({
            id: _level.id,
            name: _level.name,
            schoolId: _level.schoolId,
            description: _level.description,
            modifiedBy: _level.modifiedBy,
          });
        } else {
          resp = await addLevel({
            name: _level.name,
            schoolId: _level.schoolId,
            description: _level.description,
            createdBy: _level.createdBy,
          });
        }

        toastLAE.current.show(
          utils.toastCallback({
            severity: "success",
            summary: "Successful",
            detail: resp.responseCodeDescription,
          })
        );

        setLevelDialog(false);
        setLevel(level);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);

      if (error.response) {
        resp = error.response;

        toastLAE.current.show(
          utils.toastCallback({
            severity: "error",
            summary: "Submit Error",
            detail: resp.responseCodeDescription,
          })
        );
      } else {
        toastLAE.current.show(
          utils.toastCallback({
            severity: "error",
            summary: "Network Error",
            detail: constants.networkErrorMessage,
          })
        );
      }
    }
  };

  const deleteLevelM = () => {
    try {
      var resp = deleteLevelFunc(level);
      setDeleteLevelDialog(false);
      setLevel(level);
      toastLAE.current.show(
        utils.toastCallback({
          severity: "success",
          summary: "Successful",
          detail: resp.responseCodeDescription,
        })
      );
    } catch (error) {
      if (error.response) {
        resp = error.response;

        toastLAE.current.show(
          utils.toastCallback({
            severity: "error",
            summary: "Submit Error",
            detail: resp.responseCodeDescription,
          })
        );
      } else {
        toastLAE.current.show(
          utils.toastCallback({
            severity: "error",
            summary: "Network Error",
            detail: constants.networkErrorMessage,
          })
        );
      }
    }
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _session = { ...level };

    _session[`${name}`] = val;

    setLevel(_session);
  };

  const levelDialogFooter = (
    <React.Fragment>
      <Button label="Cancel" icon="pi pi-times" outlined onClick={hideDialog} />
      <Button
        label="Save"
        icon="pi pi-check"
        onClick={async () => await saveLevel()}
      />
    </React.Fragment>
  );

  return (
    <div>
      <Toast ref={toastLAE} />

      <Dialog
        visible={levelDialog}
        style={{ width: "32rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Level Details"
        modal
        className="p-fluid"
        footer={levelDialogFooter}
        onHide={hideDialog}
      >
        <div className="field">
          <label htmlFor="name" className="font-bold">
            Name
          </label>
          <InputText
            id="name"
            value={level.name}
            onChange={(e) => onInputChange(e, "name")}
            required
            autoFocus
            className={classNames({ "p-invalid": submitted && !level.name })}
          />
          {submitted && !level.name && (
            <small className="p-error">Name is required.</small>
          )}
        </div>
        <div className="field">
          <label htmlFor="description" className="font-bold">
            Description
          </label>
          <InputText
            id="description"
            value={level.description}
            onChange={(e) => onInputChange(e, "description")}
            required
            className={classNames({ "p-invalid": submitted && !level.description })}
            inputId="description"
            showTime
            hourFormat="12"
          />
          {submitted && !level.description && (
            <small className="p-error">Description is required.</small>
          )}
        </div>
      </Dialog>
    </div>
  );
};

export default LevelAddEdit;
